import React, { createContext, useContext, useState } from "react";

const NavProgressContext = createContext();

export function NavProgressProvider({ children }) {
  const [loading, setLoading] = useState(false);

  return (
    <NavProgressContext.Provider value={{ loading, setLoading }}>
      {children}
    </NavProgressContext.Provider>
  );
}

export function useNavProgress() {
  return useContext(NavProgressContext);
}